define(['jQuery',
        'library/fcse-compatibility/object',
        'clientComponents/googletagmanager/GtmBase',
        'moment',
        'underscore'],

    /**
     * @returns {GtmProductPage}
     */
    function ($, Object, GtmBase, moment, _) {

        function GtmProductPage(options) {
            GtmBase.apply(this, arguments);

            $('[data-fcse-role="hotel-details"] [data-fcse-role="check-offer-button"]')
                .on('click', $.proxy(this._onClickCheckOfferButton, this));
        }

        GtmProductPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmProductPage.prototype */{
            trackPage: function () {
                var $offer = $('.favorites-offer [data-fcse-role="favorites--add"]');

                if (!$offer.length) {
                    return;
                }

                try {
                    var data = {};
                    var offerData = JSON.parse($offer.data('fcse-favorites').data);
                    var $hotelDetails = $('[data-fcse-role="hotel-details"]');

                    if ($hotelDetails.length) {
                        offerData = $.extend(
                            offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
                    }

                    if (this.option('siteArea') === 'hotelDetail') {
                        data = this.getHotelDetailData(offerData)
                    } else {
                        data = this.getPackageDetailData(offerData)
                    }
                } catch (e) {
                    console.log(e);
                }

                return this.trackData(data);
            },
            getHotelDetailData: function (offerData) {
                var $firstOffer = $('[data-fcse-role="offerlist"] [data-fcse-role="offer-item"]');
                if ($firstOffer.length) {
                    $firstOffer = $firstOffer.first();
                    offerData = $.extend(offerData, $firstOffer.data());
                }

                try {
                    var data = {
                        canonicalUrl: window.location.href,
                        product: {
                            name: offerData.hotel.name,
                            id: offerData.hotel.id,
                            brand: offerData.tourOperator,
                            variant: offerData.hotel.location.city.name,
                            price: offerData.hotel.offers["0"].price.amount,
                            category: 'package/' + offerData.hotel.location.country.name + '/' + offerData.hotel.location.city.name,
                            list: offerData.hotel.location.country.name, // i.e. 'Hurghada'
                            adults: offerData.productSearch.travellers.adults.length,
                            durationOfStay: offerData.hotel.offers["0"].lengthOfStay,
                            travelDates: offerData.packageRouteParams.departureDate + '/' + offerData.packageRouteParams.returnDate
                        }
                    };

                    if (typeof offerData.productSearch.travellers.children !== "undefined") {
                        offerData.product.children = offerData.productSearch.travellers.children.length;
                    }
                } catch (e) {
                    console.log(e);
                }

                return data;
            },
            getPackageDetailData: function (offerData) {
                try {
                    var data = {
                        canonicalUrl: window.location.href,
                        product: {
                            name: offerData.hotel.name,
                            id: offerData.hotel.id,
                            brand: offerData.tourOperator,
                            variant: offerData.hotel.offers["0"].departureFlight.departureAirport.code +
                            '-' + offerData.hotel.offers["0"].departureFlight.arrivalAirport.code,
                            price: offerData.hotel.offers["0"].price.amount,
                            category: 'package/' + offerData.hotel.location.country.name + '/' + offerData.hotel.location.city.name,
                            list: offerData.hotelRegion, // i.e. 'Hurghada'
                            adults: offerData.productSearch.travellers.adults.length,
                            durationOfStay: offerData.hotel.offers["0"].lengthOfStay,
                            travelDates: moment(
                                offerData.hotel.offers["0"].departureFlight.departureDateTime
                            ).format('YYYY.MM.DD') + '/' + moment(
                                offerData.hotel.offers["0"].returnFlight.departureDateTime
                            ).format('YYYY.MM.DD')
                        }
                    };

                    if (typeof offerData.productSearch.travellers.children !== "undefined") {
                        offerData.product.children = offerData.productSearch.travellers.children.length;
                    }
                } catch (e) {
                    console.log(e);
                }

                return data;
            },
            _onClickCheckOfferButton: function (e) {
                var $elem = $(e.target);

                if ($elem.hasClass('success')) {
                    var offerData = this._getOfferData($elem);
                    var product = {};

                    if (this.option('siteArea') === 'hotelDetail') {
                        product = this.getHotelDetailData(offerData).product
                    } else {
                        product = this.getPackageDetailData(offerData).product
                    }

                    dataLayer.push({
                        'event':'shoppingCartAction',
                        'cartAction':'add',
                        product: product,
                    });
                }
            },
            _getOfferData: function ($elem) {
                var $offer = $elem.parents('[data-fcse-role="offer-item"]');
                var offerData = JSON.parse($offer.find('[data-fcse-favorites]').data('fcse-favorites').data);
                var $hotelDetails = $('[data-fcse-role="hotel-details"]');
                if ($hotelDetails.length) {
                    offerData = $.extend(
                        offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
                }

                return offerData;
            }
        });

        return GtmProductPage;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmProductPage.js